"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Stream_Graph = _interopRequireDefault(require("./Stream_Graph"));
var _data = _interopRequireDefault(require("./data.json"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
let graphStyling = {
  width: "80%",
  height: "80%"
};
function App(_ref) {
  let {
    json,
    graphStyle
  } = _ref;
  json = json === "" || json === null || json === undefined ? _data.default : json;
  graphStyle = graphStyle === "" || graphStyle === null || graphStyle === undefined ? graphStyling : graphStyle;
  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_Stream_Graph.default, {
    data: json,
    overallStyle: graphStyle
  }));
}
var _default = exports.default = App;